module.exports = __webpack_public_path__ + "479c31759042a1d88980e126129585da.png";